export default __webpack_public_path__ + "static/media/mens-banner.52698706.jpg";